import cn from 'classnames'
import { PartnerCurrencyButtons } from 'legacy/lut/components/widgets/public/partner360/PartnerCurrencyButtons'
import { PartnerTypeButtons } from 'legacy/lut/components/widgets/public/partner360/PartnerTypeButtons'
import { useActualsData } from 'legacy/lut/features/partner360/configuration/hooks/useActualsData'
import { useCurrencyData } from 'legacy/lut/features/partner360/configuration/hooks/useCurrencyData'
import { FC, useMemo } from 'react'

import { TSegmentConrolCommon } from 'cng-common/components/segmentedControl/models'
import { useFormField } from 'cng-common/features/form'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import styles from './ValueTypeAndCurrency.module.scss'

interface IGoalProps {
  initialCurrency?: string | null
  initialValueType?: string | null
  formKey: string
  size?: TSegmentConrolCommon['size']
}

export const ValueTypeAndCurrency: FC<IGoalProps> = ({
  initialValueType,
  initialCurrency,
  formKey,
  size,
}) => {
  const { currency, localCurrency } = useCurrencyData()
  const { actualsValueType, actualsValueTypes } = useActualsData()
  const { value: formCurrency, handleChange: handleCurrencyChange } = useFormField({
    defaultValue: initialCurrency || currency,
    formKey,
    field: 'currency',
  })

  const { value: formValueType, handleChange: handleValueTypeChange } = useFormField({
    defaultValue: initialValueType || actualsValueType,
    formKey,
    field: 'valueType',
  })

  const actualsTypes = useMemo(() => {
    return actualsValueTypes?.length
      ? actualsValueTypes
      : Object.values(ActualsValueTypes).filter((el) => !!el)
  }, [actualsValueTypes])

  return (
    <div className={styles.controls}>
      <PartnerCurrencyButtons
        localCurrency={localCurrency}
        currency={formCurrency}
        setCurrency={handleCurrencyChange}
        className={cn(styles.currencySwitcher, size !== 'small' && styles.buttonSize)}
        size={size}
      />
      <div className={styles.separator} />
      <PartnerTypeButtons
        buttonCurrType={formValueType}
        setButtonCurrType={handleValueTypeChange}
        buttonTypes={actualsTypes}
        translationKey="jbp-partner-actuals-value-type"
        className={cn(styles.valueType, size !== 'small' && styles.buttonSize)}
        size={size}
      />
    </div>
  )
}
